import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breakpoints } from "cityads-v3/utils/styleUtils";

import {
  setIsMobile
} from 'cityads-v3/actions/app';

@connect(state => ({
  isMobile: state.app.isMobile
}))
export default class AppReduce extends Component {

  static propTypes = {
    isMobile: PropTypes.bool
  }

  componentDidMount() {

    if (window) {
      window.addEventListener('resize', this._resizeHandler = this.checkIsMobile.bind(this));
      this.checkIsMobile();
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resizeHandler);
  }

  checkIsMobile() {
    if (window) {
      const isMobile = window.innerWidth <= parseInt(breakpoints.sm, 10);

      if (isMobile !== this.props.isMobile) {
        this.props.dispatch(setIsMobile(isMobile));
      }

      return isMobile;
    }

    return false;
  }

  render() {
    return null;
  }

}
